import { isTeamsAppEnabled as isTeamsAppEnabledBase } from '@atlaskit/teams-app-config/is-teams-app-enabled';
import {
	navigateToTeamsApp as navigateToTeamsAppBase,
	toTeamsAppURL,
} from '@atlaskit/teams-app-config/navigation';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { useSessionData } from '@confluence/session-data';
import { getIsNav4Enabled, useIsNav4Enabled } from '@confluence/nav4-enabled';
import { useRouteActions } from '@confluence/route-manager';

export const useNavigateToTeamsApp = (
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const { cloudId, orgId } = useSessionData();
	const { push } = useRouteActions();
	const isNav4Enabled = useIsNav4Enabled();

	if (!orgId) {
		throw new Error('Org ID is required to navigate to Teams App');
	}

	return navigateToTeamsAppBase({
		push,
		hostProduct: 'confluence',
		orgId,
		cloudId,
		userHasNav4Enabled: isNav4Enabled,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};

export const getNavigateToTeamsApp = (
	orgId: string,
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	if (!orgId) {
		throw new Error('Org ID is required to navigate to Teams App');
	}
	const isNav4Enabled = getIsNav4Enabled();

	return navigateToTeamsAppBase({
		hostProduct: 'confluence',
		orgId,
		userHasNav4Enabled: isNav4Enabled,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};

export const useTransformToTeamsAppUrl = (path: string, search = '') => {
	const { cloudId, orgId } = useSessionData();

	return toTeamsAppURL(path, search, {
		orgId,
		cloudId,
	});
};

export const isTeamsAppEnabled = () => {
	return isTeamsAppEnabledBase({
		userHasNav4Enabled: getIsNav4Enabled(),
		hostProduct: 'confluence',
	});
};
